/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { classnames as cx } from '@ba-ui-toolkit/utils';
import styles from './Slider.scss';
import TooltipWrapper from './TooltipWrapper';

const sliderClassName = styles.sliderClassName.replace(/"/g, '');

export default class Handle extends Component {
	static propTypes = {
		className: PropTypes.string,
		handleRef: PropTypes.func,
		value: PropTypes.number.isRequired,
		style: PropTypes.object,
		showTooltip: PropTypes.bool,
		labelFormatter: PropTypes.func.isRequired,
		onMouseEnter: PropTypes.func,
		onMouseLeave: PropTypes.func,
		onTouchStart: PropTypes.func,
		onTouchMove: PropTypes.func,
		onTouchEnd: PropTypes.func,
		onMouseDown: PropTypes.func,
		onKeyDown: PropTypes.func,
		inverted: PropTypes.bool,
	};

	state = {
		showFocusClass: false,
	};

	_onFocus = () => {
		this.setState({ showFocusClass: true });
	};

	_onBlur = () => {
		this.setState({ showFocusClass: false });
	};

	render() {
		const {
			className,
			handleRef,
			value,
			style,
			onKeyDown,
			onMouseDown,
			onTouchStart,
			onTouchMove,
			onTouchEnd,
			showTooltip,
			labelFormatter,
			inverted,
		} = this.props;
		const containerProps = {
			className: cx(`${sliderClassName}__handle`, `${className}`),
			ref: node => {
				this._containerRef = node;
			},
			style,
			showTooltip,
			orient: 'top',
			title: labelFormatter(value),
		};

		const handleProps = {
			className: cx(`${sliderClassName}__handle__input`, {
				focus: this.state.showFocusClass,
				inverted,
			}),
			ref: handleRef,
			onMouseDown,
			onTouchStart,
			onTouchMove,
			onTouchEnd,
			onKeyDown,
			tabIndex: 0,
			onKeyUp: this._onFocus,
			onBlur: this._onBlur,
		};

		return (
			<TooltipWrapper {...containerProps}>
				<div {...handleProps} />
			</TooltipWrapper>
		);
	}
}
